





















import { CanalLead, CanalLeadService } from "@/services/canal-lead.service";
import Modal from "@/shared/components/modal.vue";
import { required } from "@/shared/validators";
import Vue from "vue";
import Component from "vue-class-component";
import { Emit } from "vue-property-decorator";

@Component({
  components: {
    Modal,
  },
})
export default class ManterCanalProspeccao extends Vue {
  idCanalLead: number | null = null;
  nome = "";
  rules = {
    nome: [required()],
  };
  loading = false;

  get titulo(): string {
    return (
      (this.idCanalLead && "Alterar Canal de Prospecção") ||
      "Adicionar Canal de Prospecção"
    );
  }

  abrirModal(idCanalLead?: number): Promise<boolean> {
    const modal = this.$refs.modal as Modal;

    this.idCanalLead = null;
    this.nome = "";
    const p = modal.open();

    if (idCanalLead !== undefined) {
      return this.fetchCanalLead(idCanalLead).then(() => p);
    }

    return p;
  }

  fechar() {
    const modal = this.$refs.modal as Modal;
    const p = modal.close(false);
    return p;
  }

  fetchCanalLead(id: number): Promise<void> {
    this.loading = true;
    this.idCanalLead = id;
    return CanalLeadService.obter(id)
      .then((canal) => {
        this.nome = canal.nome;
      })
      .finally(() => (this.loading = false));
  }

  salvar() {
    const form = this.$refs.form as any;
    if (form.validate()) {
      this.loading = true;
      (
        (this.idCanalLead &&
          CanalLeadService.alterarCanalLead(this.idCanalLead, {
            nome: this.nome,
          })) ||
        CanalLeadService.cadastrarCanalLead({
          nome: this.nome,
        })
      )
        .then((canal) => this.onCadastroSuccess(canal))
        .finally(() => (this.loading = false));
    }
  }

  @Emit("onCadastroSuccess")
  onCadastroSuccess(canalLead: CanalLead) {
    const modal = this.$refs.modal as Modal;
    modal.close(!!canalLead);
  }
}
